import { useEffect } from 'react';

// Keeps the embedding iframe sized to the app's content. The parent theme
// listens for `{ frameHeight }` postMessages and sets the iframe height, so we
// post the current body height on mount and again whenever the body resizes
// (debounced, so a burst of layout changes collapses into a single post). The
// targetOrigin is '*' to match every other postMessage in this app; the parent
// validates the message shape.
const usePostFrameHeight = () => {
  useEffect(() => {
    const postHeight = () => {
      window.parent.postMessage({
        'frameHeight': document.body.scrollHeight
      }, '*');
    };

    // Fire once immediately so the frame is sized on first paint.
    postHeight();

    // Some engines / test runners lack ResizeObserver; the mount-time post
    // above already covers the initial layout, so just skip the observer.
    if (typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    let timer = null;
    const observer = new ResizeObserver(() => {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(postHeight, 150);
    });

    observer.observe(document.body);

    return () => {
      observer.disconnect();

      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);
};

export default usePostFrameHeight;
